import "./all-tim.css"
import { useLocation, useNavigate } from "react-router-dom"
import InfoBox from "../../components/infoBox/InfoBox";
import RectangleCardTim4 from "../../components/rectangleCardTim4/RectangleCardTim4";
import HeaderSecondary from "../../components/headerSecondary/HeaderSecondary";
import DownBar from "../../components/downBar/DownBar";
import { useEffect, useState } from "react";
import AuthService from "../../Auth/auth";
import Button1 from "../../components/Button1";
import Loader from "../../components/Loader/Loader";
import Mod1 from "../../components/mod1/Mod1";
import infoIcon from "../../assets/images/infoIcon.svg"
import { SpotWSS } from 'wf-utils/spot/spot-wss';
import config from "../../config";


function AllTimGen4() {
    const location = useLocation();
    const navigate = useNavigate();
    const maxValid = 4;
    const minValid = 1;
    const retestAttemt = 3;

    const [downBar, setDownBar] = useState(false);
    const [dataForDownBar, setDataForDownBar] = useState({});
    const [timdevices, setTimDevices] = useState(location.state.child ? location.state.child : location.state.parent)
    const [loading, setloading] = useState(true);
    const [modalDetails, setmodalDetails] = useState({
        primaryText: "Number of Testers",
        secondaryText: `Please share with how many people you will be running this test.(max ${maxValid})`,
        icon: infoIcon,
        inputBox: true,
        confirmButtonText: "Done"
    });
    const [modalInputBox, setModalInputBox] = useState(1);
    const [testButtonClicked, setTestButtonClicked] = useState(false)
    const [dataForTest, setDataForTest] = useState({})
    const [infoBoxText, setinfoBoxText] = useState({ text: "test" })
    const [showResetModal, setShowResetModal] = useState(false);
    const [resetTargetDevice, setResetTargetDevice] = useState(null);
    // Captured once on mount so it survives the history-state cleanup below,
    // and so it doesn't resurrect the modal on a later `navigate(-1)` (e.g. "Rerun Test").
    const [startTestingAssetId] = useState(location.state.startTestingAssetId || null);
    const [showStartTestingModal, setShowStartTestingModal] = useState(!!startTestingAssetId);
    const [enablingDebugAssetIds, setEnablingDebugAssetIds] = useState(new Set());

    useEffect(() => {
        if (startTestingAssetId) {
            navigate(location.pathname, {
                replace: true,
                state: { ...location.state, startTestingAssetId: null }
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    let floorName = location.state.floorDetails[0].name;
    useEffect(() => {
        async function fetchAgentId() {
            setloading(true)
            let rawDatawithAgentId = {}
            let deviceIdArr = (timdevices).map(obj =>
                obj.device.id
            );
            deviceIdArr.forEach(deviceId => {
                rawDatawithAgentId[deviceId] = location.state.rawData[deviceId]
            })
            location.state.rawData = rawDatawithAgentId
            const key = localStorage.getItem("spaceio-key")


            const timDev = location.state.child ? [...location.state.child] : [...location.state.parent];

            for (let i = 0; i < timDev.length; i++) {
                timDev[i]["macId"] = location.state.rawData[timDev[i].device.id].hardware.deviceId
            }

            if (location.state.child) location.state.child = timDev
            else location.state.parent = timDev

            let result2 = await Promise.all(timDev.map(async (val) =>
                AuthService.readDataSPOT(key, Array(`${val.assetId}`))
            ))

            for (let i = 0; i < timDev.length; i++) {
                timDev[i]['spotData'] = result2[i][0]
            }
            let timDevSetUpObj = {}
            let setUp = []
            let calstatus = []
            let calibrationStatus = []
            timDev.forEach(obj => {
                setUp.push(obj.spotData.setup_status)
                calstatus.push(obj.spotData.cal_status)
                calibrationStatus.push(obj.spotData.calibration_status)
                timDevSetUpObj = {
                    setup_status: setUp,
                    cal_status: calstatus,
                    calibration_status: calibrationStatus,
                }
            })
            if (timDevSetUpObj["setup_status"].every(status => status === 1) && timDevSetUpObj["cal_status"].every(status => (status === 2 || status === 3)) && (timDevSetUpObj["calibration_status"].every(status => status === 0) || timDevSetUpObj["calibration_status"].includes(1))) {
                setinfoBoxText({ text: "Set-up for all the TiMs in this room is done now." });

            }
            else {
                setinfoBoxText({ text: "Set up all the TIM4 devices in each room and then proceed to testing each device. If you want to reset the setup parameters use \"Edit Dimensions\"." });

            }
            //check this
            if (timDevSetUpObj["cal_status"].every(status => status === 3) && (timDevSetUpObj["calibration_status"].every(status => status === 3))) setinfoBoxText({ text: "Click on respective test button" })
            else if (timDevSetUpObj["cal_status"].every(status => status === 2) && (timDevSetUpObj["calibration_status"].every(status => (status === 2 || status === 1)))) {
                setinfoBoxText({ text: "Device not responding. Please recalibrate." })
            }
            setTimDevices(timDev);
            setloading(false)

        }
        fetchAgentId()


    }, [])



    const setModalDetailsAfterCheck = (value) => {

        let val = parseInt(value)
        setModalInputBox(val)
        setTimeout(function () {
            if (val < minValid) setModalInputBox(1)
            else if (val > maxValid) setModalInputBox(maxValid)
        }
            , 1500)
    }


    const handleRectangleCardClickForSetUp = (timData) => {
        let data = {}
        data["batteryVoltage"] = timData.batteryVoltage;
        data["markerId"] = timData.serial;
        data["lastUpdated"] = timData.lastUpdated;
        data["deviceId"] = addDashes(timData.device.id, [4, 3, 3]);
        data["spaceName"] = timData.name;
        data["spaceId"] = timData.id;
        data["locationId"] = timData.locationId;
        data["status"] = timData.status;
        data["assetId"] = timData.assetId;
        data['blessId'] = addDashes(timData.device.blessId, [4, 3, 3]);
        data['productId'] = timData.device.hardware.productId;
        data['x_value'] = timData.spotData.x_value;
        data['y_value'] = timData.spotData.y_value;

        let setUpStatus = (timData.spotData || {}).setup_status
        let calSetUp = (timData.spotData || {}).cal_status
        let calibrationStatus = (timData.spotData || {}).calibration_status
        let instalationStatus = (timData.spotData || {}).instalation_status
        let cal = {
            height: (timData.spotData || {})["height_set"],
            orientation: (timData.spotData || {})["orientation_set"]
        }

        let instalationData = { peopleCount: (timData.spotData || {})["people_count"] }
        if (instalationStatus > 0) {
            if (instalationStatus === 1) {
                data["calibration"] = {
                    span: <span className="rectangle-card-body-top-content1-setUp-done" style={{ background: "#29CF81" }}>
                        Test Passed
                    </span>,
                    ...cal,
                }
                data["instalationData"] = { ...instalationData }
            }
            else if (instalationStatus === 2) {
                data["calibration"] = {
                    span: <span className="rectangle-card-body-top-content1-setUp-done" style={{ background: "#29CF81" }}>
                        Partial Passed
                    </span>,
                    ...cal,
                }
                data["instalationData"] = { ...instalationData }
            }
            else if (instalationStatus === 3) {
                data["calibration"] = {
                    span: <span className="rectangle-card-body-top-content1-setUp-done" style={{ background: "#F65162" }}>
                        Test Failed
                    </span>,
                    ...cal,
                }
                data["instalationData"] = { ...instalationData }
            }
            else {
                data["calibration"] = {
                    span: <span className="rectangle-card-body-top-content1-setUp-done" style={{ background: "#F65162" }}>
                        Test Error
                    </span>,
                    ...cal,
                }
                data["instalationData"] = { ...instalationData }
            }
        }
        else {

            if (setUpStatus !== 0) {
                if (setUpStatus === 1 && calSetUp === 2 && calibrationStatus === 0) {
                    data["calibration"] = {
                        span: <span className="rectangle-card-body-top-content1-setUp-done" style={{ background: "#29CF81" }}>
                            Set-up done
                        </span>,
                        ...cal
                    }

                }

                else if (setUpStatus === 1 && calSetUp === 2 && calibrationStatus === 1) {
                    data["calibration"] = {
                        span: <span className="rectangle-card-body-top-content1-setUp-done" style={{ background: "#BBBBBB" }}>
                            Tim Offline
                        </span>,
                        ...cal
                    }
                }
                else if (setUpStatus === 1 && calSetUp === 2 && calibrationStatus === 2) {

                    data["calibration"] = {
                        span: <span className="rectangle-card-body-top-content1-setUp-done" style={{ background: "#F65162" }}>
                            Not Detected
                        </span>,
                        ...cal
                    }


                }
                else if (setUpStatus === 1 && calSetUp === 3 && calibrationStatus === 3) {
                    data["calibration"] = {
                        span: <span className="rectangle-card-body-top-content1-setUp-done" style={{ background: "#29CF81" }}>
                            Debug 
                        </span>,
                        ...cal
                    }

                }
                else {
                    data["calibration"] = {
                        span: <span className="rectangle-card-body-top-content1-setUp-done" style={{ background: "#F65162" }}>
                            Error
                        </span>,
                        ...cal
                    }
                }
            }
        }

        setDataForDownBar(data)
        setDownBar(!downBar)
    }

    const handleRectangleCardButtonClickFortest = (timData) => {
        setmodalDetails({
            primaryText: "Number of Testers",
            secondaryText: `Please share with how many people you will be running this test.(max ${maxValid})`,
            icon: infoIcon,
            inputBox: true,
            confirmButtonText: "Done"
        })
        setTestButtonClicked(true)
        let data = {};
        data["deviceId"] = timData.device.id;
        data["spaceName"] = timData.name;
        data["spaceId"] = timData.id;
        data["locationId"] = timData.locationId;
        data["status"] = timData.status;
        data["assetId"] = timData.assetId
        data["test"] = modalInputBox
        data["spotData"] = timData.spotData
        data["macId"] = timData.macId
        data["spaceName"] = timData.name;
        data['productId'] = timData.device.hardware.productId;
        data['x_value'] = timData.spotData.x_value;
        data['y_value'] = timData.spotData.y_value;

        setDataForTest(data)
    }

    const handleConfirmButtonClickedForTest = async () => {
        if (modalInputBox >= minValid && modalInputBox <= maxValid) {
            setloading(true)
            setDataForTest({ ...dataForTest, test: modalInputBox })
            navigate("/live-grid-tim4",
                { state: { ...location.state, dataForTest: { ...dataForTest, test: modalInputBox } } })
        }
    }

    const onCardClick = (timData, setupClicked) => {
        let data = {}
        if (setupClicked) {
            data["batteryVoltage"] = timData.batteryVoltage;
            data["markerId"] = timData.serial;
            data["lastUpdated"] = timData.lastUpdated;
            data["deviceId"] = addDashes(timData.device.id, [4, 3, 3]);
            data['blessId'] = addDashes(timData.device.blessId, [4, 3, 3])
            data["spaceName"] = timData.name;
            data["spaceId"] = timData.id;
            data["locationId"] = timData.locationId;
            data["status"] = timData.status;
            data["assetId"] = timData.assetId;
            data['productId'] = timData.device.hardware.productId;
            data['x_value'] = timData.spotData.x_value;
            data['y_value'] = timData.spotData.y_value;
            data['macId'] = timData.macId;
            data['deviceAssetId'] = ((location.state.rawData || {})[timData.device.id] || {}).assetId;
            setDataForDownBar(data)
        }

        navigate("/gridTim4",
            { state: { ...location.state, "dataForDownBar": setupClicked ? data : dataForDownBar, } })
    }

    const addDashes = (deviceId, dashPosition) => {
        deviceId = deviceId.toString()
        return deviceId.slice(0, dashPosition[0]) + "-" + deviceId.slice(dashPosition[0], dashPosition[0] + dashPosition[1]) + "-" + deviceId.slice(dashPosition[0] + dashPosition[1], dashPosition[0] + dashPosition[1] + dashPosition[2])
    }

    const onResetClick = async (timData) => {
        setloading(true);
        let utcTimestamp = Math.floor(new Date().getTime() / 1000);
        const resetData = {
            "setup_status": 0,
            "cal_status": 0,
            "calibration_status": 0,
            "instalation_status": 0,
            "utcEpoch": utcTimestamp,
            "test_status": [0, 0, 0, 0, 0],
            "people_count": [0, 0, 0, 0]
        };
        let dataToWrite = [{
            "assetId": timData.assetId,
            "data": { ...timData.spotData, ...resetData }
        }];
        await AuthService.writeDataToSpot(dataToWrite);
        setShowResetModal(false);
        setResetTargetDevice(null);
        setloading(false);
        onCardClick({ ...timData, spotData: { ...timData.spotData, ...resetData } }, true);
    };

    const watchForTestReady = (spaceAssetId, deviceAssetId) => {
        const key = window.localStorage.getItem('spaceio-key');
        let frameCount = 0;
        const spotWs = new SpotWSS({
            subscriptions: [{ assetId: deviceAssetId, templateId: 23 }],
            wsUrl: config.WEB_SOCKET_URL,
            token: key,
            onData: ({ data }) => {
                // Template 23 frames carry no `count`; their arrival is the signal
                // that the device is in debug mode and reporting. Two back-to-back
                // frames confirm it is live and test-ready.
                if (!data) return;
                frameCount += 1;
                if (frameCount >= 2) {
                    setEnablingDebugAssetIds(prev => {
                        const next = new Set(prev);
                        next.delete(spaceAssetId);
                        return next;
                    });

                    let utcTimestamp = Math.floor(new Date().getTime() / 1000);
                    const updatedDevices = timdevices.map(d =>
                        d.assetId === spaceAssetId
                            ? { ...d, spotData: { ...d.spotData, utcEpoch: utcTimestamp, cal_status: 3, calibration_status: 3 } }
                            : d
                    );
                    setTimDevices(updatedDevices);

                    const target = updatedDevices.find(d => d.assetId === spaceAssetId);
                    if (target) {
                        AuthService.writeDataToSpot([{ assetId: spaceAssetId, data: target.spotData }]);
                    }

                    spotWs.disposeConnection();
                }
            },
        });
    };

    // rawData is keyed by the numeric device id, so read the device asset id from
    // the selected device. This is the same lookup LiveGridTIM-4 uses to subscribe.
    const getDeviceAssetId = async (spaceAssetId) => {
        const selectedDevice = timdevices.find(d => d.assetId === spaceAssetId);
        const deviceId = selectedDevice?.device?.id;
        if (!deviceId) return null;

        const deviceAssetId = location.state.rawData[deviceId]?.assetId;
        if (deviceAssetId) return deviceAssetId;

        // Older floors can miss assetId in rawData, so fall back to the API.
        const fetched = await AuthService.getAssetIdFromDeviceAssetId(deviceId);
        return fetched?.assetId || null;
    };

    const onConfirmStartTesting = async () => {
        // Read the captured copy: the mount effect clears
        // `location.state.startTestingAssetId` so the modal does not reappear.
        const spaceAssetId = startTestingAssetId;
        setShowStartTestingModal(false);
        if (!spaceAssetId) return;

        setEnablingDebugAssetIds(prev => new Set(prev).add(spaceAssetId));

        let deviceAssetId = null;
        try {
            deviceAssetId = await getDeviceAssetId(spaceAssetId);
        } catch (err) {
            console.error("Failed to resolve device asset id", err);
        }

        // Without a device asset id there is nothing to subscribe to. Clear the
        // enabling state so the card does not stay stuck in the spinner.
        if (!deviceAssetId) {
            setEnablingDebugAssetIds(prev => {
                const next = new Set(prev);
                next.delete(spaceAssetId);
                return next;
            });
            return;
        }

        watchForTestReady(spaceAssetId, deviceAssetId);
    };

    const goBack = () =>
        navigate(
            {
                pathname: "/selectTim4Floor",
                search: `?floor=${location.state.floorDetails[0].id}&name=${floorName}`,
                state: { ...location.state }
            }
        )


    return (
        <div className="container-fluid g-0">
            {showResetModal && (
                <div style={{
                    position: 'fixed', inset: 0, zIndex: 1050,
                    background: 'rgba(0,0,0,0.45)',
                    display: 'flex', alignItems: 'center', justifyContent: 'center'
                }}>
                    <div style={{
                        background: '#fff', borderRadius: '12px',
                        padding: '28px 24px',
                        maxWidth: '380px', width: '90%',
                        boxShadow: '0 8px 32px rgba(0,0,0,0.18)'
                    }}>
                        <p style={{ fontWeight: 700, fontSize: '16px', color: '#2E375B', marginBottom: '8px' }}>Edit Dimensions</p>
                        <p style={{ fontSize: '14px', color: '#555', marginBottom: '24px' }}>
                            This will reset this TIM device's status back to Set-up and take you to the setup page to edit its dimensions.
                        </p>
                        <div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end' }}>
                            <button className="buttonStandard2" onClick={() => { setShowResetModal(false); setResetTargetDevice(null); }}>
                                Cancel
                            </button>
                            <button className="buttonStandard2" style={{ background: '#FF9777', color: '#fff', borderColor: '#FF9777' }} onClick={() => onResetClick(resetTargetDevice)}>
                                Continue
                            </button>
                        </div>
                    </div>
                </div>
            )}
            {showStartTestingModal && (
                <div style={{
                    position: 'fixed', inset: 0, zIndex: 1050,
                    background: 'rgba(0,0,0,0.45)',
                    display: 'flex', alignItems: 'center', justifyContent: 'center'
                }}>
                    <div style={{
                        background: '#fff', borderRadius: '16px',
                        padding: '28px',
                        maxWidth: '460px', width: '90%',
                        boxShadow: '0 8px 32px rgba(0,0,0,0.18)'
                    }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                            <img src={infoIcon} alt="" style={{ width: '32px', height: '32px', flexShrink: 0 }} />
                            <span style={{ fontSize: '18px', fontWeight: 700, color: '#2E375B' }}>To Start Testing</span>
                        </div>
                        <p style={{ margin: '18px 0 0', fontSize: '15px', color: '#2E375B', lineHeight: '1.6' }}>
                            Power on the device and install it in position before you begin.
                        </p>
                        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '12px', marginTop: '24px' }}>
                            <Button1
                                text="OK"
                                borderRadius="24px"
                                background="linear-gradient(90deg, #38D68B 0%, #2BBE7A 100%)"
                                color="#ffffff"
                                style={{ width: 'auto', minWidth: '100px', margin: 0, padding: '0 20px' }}
                                onClick={onConfirmStartTesting}
                            />
                        </div>
                    </div>
                </div>
            )}
            <div class="row justify-content-center g-0 mainDiv">
                <div className="col-sm-12 col-lg-8 position-relative" style={{ background: "#F5F5F5" }}>
                    <div className="row g-0" style={{ height: "100%", display: "flex", flexDirection: "column" }}>
                        {loading && <Loader />}

                        <div className="col-11 mx-auto">
                            <HeaderSecondary tabInd={downBar || testButtonClicked}
                                goBack={goBack}
                                primaryText={location.state.parent[0].name}
                                secondaryText={[location.state.floorDetails[0].name, "   ", location.state.floorDetails[0].anchorAddress]}
                                buttonSecondary={<button tabIndex={downBar || testButtonClicked ? -1 : 0} className="header-secondary-content2" onClick={() => navigate("/floor-planview", { state: { ...location.state, data: timdevices } })}>View on floor plan</button>}
                            />
                        </div>
                        <div className="col-11 mx-auto my-4">
                            <InfoBox text={infoBoxText.text} />
                        </div>

                        {testButtonClicked ?
                            <div className="col-10 col-sm-6 col-lg-6 mx-auto ">
                                <Mod1 text={{ primaryText: modalDetails.primaryText, secondaryText: modalDetails.secondaryText, icon: modalDetails.icon }}
                                    closeModal={() => setTestButtonClicked(false)}
                                    confirmButton={{ text: modalDetails.confirmButtonText, onClick: handleConfirmButtonClickedForTest }}
                                    inputBox={modalDetails.inputBox}
                                    value={modalDetails.inputBox ? modalInputBox : null}
                                    setValue={modalDetails.inputBox ? setModalDetailsAfterCheck : null}
                                    tabInd={downBar}
                                />
                            </div>
                            : null}

                        <div className="col-11 mx-auto">
                            {
                                (timdevices).map((obj, index) => {
                                    let instalationStatus = (obj.spotData || {}).instalation_status
                                    let calstatus = (obj.spotData || {}).cal_status
                                    let calibrationStatus = (obj.spotData || {}).calibration_status
                                    let setUpStatus = (obj.spotData || {}).setup_status
                                    let retest = (obj.spotData || {}).test_status
                                    retest = retest ? retest[retest.length - 1] : {}
                                    if (retest > 0 && retest <= retestAttemt) retest = true
                                    else retest = false

                                    return (

                                        <RectangleCardTim4
                                            tabInd={downBar || testButtonClicked}
                                            key={obj.device.id}
                                            markerId={obj.serial}
                                            productId={obj.device.hardware.productId}
                                            deviceName={obj.name}
                                            deviceId={addDashes(obj.device.blessId, [4, 3, 3])}
                                            onClick={() => handleRectangleCardClickForSetUp(obj)}
                                            setUpDevice={(e) => { e.stopPropagation(); onCardClick(obj, true) }}
                                            onTestingClick={(e) => { e.stopPropagation(); handleRectangleCardButtonClickFortest(obj) }}
                                            setUpStatus={setUpStatus}
                                            calSetUp={calstatus}
                                            calibrationStatus={calibrationStatus}
                                            instalationStatus={instalationStatus}
                                            retest={retest ? (e) => { e.stopPropagation(); handleRectangleCardButtonClickFortest(obj) } : null}
                                            onResetClick={setUpStatus > 0 ? () => { setResetTargetDevice(obj); setShowResetModal(true); } : null}
                                            enablingDebug={enablingDebugAssetIds.has(obj.assetId)}
                                        />
                                    )


                                })
                            }
                        </div>
                        {<div className="col-12 mx-auto">
                            <DownBar deviceData={dataForDownBar}
                                className={downBar ? "downbar-card" : "downbar-card hide"}
                                closeDownBar={() => { setDownBar(!downBar) }}
                                onClick={dataForDownBar.calibration ? () => setDownBar(!downBar) : onCardClick}
                                buttonText={dataForDownBar.calibration ? "Done" : "Set-Up TIM"}
                            />
                        </div>
                        }
                    </div>
                </div>
            </div>
        </div>);
}

export default AllTimGen4;